import { actions, selectors } from '@sloyd/store-base';
import '@sloyd/types';
import { bridge } from '@sloyd/viewer';
import { put, select } from 'saga-ts';
import { invokeEvent } from 'shared-base';

export function* nudgeGolden(delta: number) {
  try {
    const goldens = yield* select(selectors.base.$goldens);
    const goldenId = yield* select(selectors.single.$currentGoldenId);
    const golden = goldens.findIndex((g) => g.id === goldenId);

    if (golden < 0) return;

    const nextIndex = golden + delta;
    const nextGolden = goldens[nextIndex];
    if (!nextGolden) return;
    invokeEvent('golden/change', { id: nextGolden.id });
    bridge.replaceModel('main', nextGolden.model);
    yield put(actions.currentIds.patch({ goldenId: nextGolden.id }));
  } catch (err) {}
}
